<template>
    <div>
        <div class="mt-2 text-lg">Como os produtos serão organizados?</div>

        <div class="flex vx-row w-full justify-center">
            <div class="vx-col w-full p-2 m-3 cursor-pointer"
                @click="() => $emit('input', true)">
                <h4>Simplificado</h4>
                <div class="shadow-md rounded option-card mt-6"
                    :class="{ 'selected': value, 'shadow-md': value }" >
                    <div class="flex">
                        <img class="vx-col w-1/4" src="https://via.placeholder.com/100">
                        <div class="flex p-2 w-full items-center">
                            <div class="text-left">
                                <h3>Título</h3>
                                <span class="text-sm">Descrição curta de até 3 linhas</span>
                            </div>
                        </div>
                        <div class="flex justify-end items-center mt-2 mr-2">
                            <div class="p-1 rounded tag">R$ 9,90</div>
                        </div>
                    </div>
                </div>
            </div>

            <h4 class="w-full p-2 m-3 mb-0 pb-0">Destacado</h4>
            <div class="vx-col md:w-1/2 sm:w-2/3 p-2 m-3 cursor-pointer"
                style="height: 300px;"
                @click="() => $emit('input', false)">
                <div>
                    <vs-card actionable :class="{ 'selected': !value }"
                        class="option-card gambeta">
                        <div slot="media">
                            <img src="https://via.placeholder.com/500">
                        </div>
                        <div>
                            <h3>Título</h3>
                            <span class="text-sm">Descrição curta de até 3 linhas</span>
                            <br/>
                            <div class="flex justify-end mt-2">
                                <div class="p-1 rounded tag">R$ 9,90</div>
                            </div>
                        </div>
                    </vs-card>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: Boolean
        },
    }
</script>

<style lang="scss" scoped>
    .option-card {
        position: relative;
        opacity: 0.5;
        transition: all 0.25s;
        user-select: none;
    }
    .selected {
        opacity: 1 !important;
        border: 3px #fc9393 solid;
    }
    .tag {
        border: 1px red solid;
        width: fit-content;
        height: fit-content;
        white-space: nowrap;
    }
    .gambeta {
        transform: scale(.85);
        position: relative;
        top: -15px;
        height: 330px;
    }
</style>